import React, { Component } from 'react'
import Footer from '../component/Footer/footer'
import './sports.scss'
import img183 from '../assets/img/183.jpg'
import img184 from '../assets/img/184.jpg'
import img185 from '../assets/img/185.jpg'
class Sports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobile: false
        }
    }
    componentDidMount() {
        if (document.body.clientWidth < 1000) {
            this.setState({
                mobile: true
            })
        } else {
            this.setState({
                mobile: false
            })
        }
    }
    componentWillUnmount() {
        window.scrollTo(0, 0)
    }
    render() {
        const { mobile } = this.state
        return (
            <div>
                <img alt='img1' className='mission_Img' src={img183} />
                {mobile ? <div className='mobile_com'>
                    <div className='title'>希格斯投资的体育活动</div>
                    <p>很多项目的体育活动，你都能在希格斯投资找到很好的玩伴，例如滑板、网球、篮球，健身，长跑，甚至跑酷等等。</p>
                    <img alt='img1' className='img' src={img184} />
                    <div className="right">
                        <img alt='img1' className='img1' src={img185} />
                    </div>
                </div> :
                    <div className="competition_content">
                        <div className='title'>希格斯投资的体育活动</div>
                        <div className="top">
                            <div className="right">
                                <p>很多项目的体育活动，你都能在希格斯投资找到很好的玩伴，例如滑板、网球、篮球，健身，长跑，甚至跑酷等等。</p>
                                <img alt='img1' className='img' src={img184} />
                            </div>
                            <div className="left">
                                <img alt='img1' className='img' src={img185} />
                            </div>
                        </div>
                    </div>
                }
                <Footer></Footer>
            </div>
        );
    }
}

export default Sports;